/**
 * 映射渲染类
 */
class MapperDraw {

  /**
   * 构造函数
   * @param mapperInfo 映射关系
   * @param canvas
   * @param context canvas Context
   * @param leftStage 左侧组件
   * @param rightStage 右侧组件
   */
  constructor(mapperInfo, canvas, context, leftStage, rightStage) {
    this.mapperInfo = mapperInfo
    this.canvas = canvas
    this.context = context
    this.leftStage = leftStage
    this.rightStage = rightStage
    this.cw = canvas.clientWidth * window.devicePixelRatio
    this.ch = canvas.clientHeight * window.devicePixelRatio

    this.leftYOffSet = 0
    this.rightYOffSet = 34

    //监听左侧容器滚动
    this.leftStage.addEventListener("scroll", () => {
      this.draw()
    })
    this.rightStage.addEventListener("scroll", () => {
      this.draw()
    })
  }

  /**
   * 渲染
   */
  draw() {
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    let scrollTop = this.leftStage.scrollTop
    let _scrollTop = this.rightStage.scrollTop
    this.mapperInfo.forEach(map => {
      //获取映射 A端 坐标 = 节点在容器中固定定位 - 父容器滚动距离
      let aY = map.aEnd.offsetY - scrollTop + this.leftYOffSet
      let zY = map.zEnd.offsetY - _scrollTop + this.rightYOffSet
      this.context.beginPath()
      this.context.moveTo(0, aY)
      this.context.lineTo(this.cw, zY)
      this.context.closePath()
      this.context.stroke()
    })
  }
}

export {MapperDraw}



//////////////////
// WEBPACK FOOTER
// ./static/js/mapper-draw.js
// module id = null
// module chunks = 